const isDevelopment = process.env.NODE_ENV === "development" || window.location.hostname === "localhost";

// ✅ Emulator/Local URL
const LOCAL_FUNCTION_URL = "http://127.0.0.1:5001/odi-logistics-app/europe-west2/api"; 
// (Note: I updated 'us-central1' to 'europe-west2' in the local path too, just in case)

const PRODUCTION_FUNCTION_URL = '/api'; // Using Firebase Hosting rewrites

export const API_BASE_URL = isDevelopment ? LOCAL_FUNCTION_URL : PRODUCTION_FUNCTION_URL;
// Debug logging
console.log('🌐 API Base URL:', API_BASE_URL);
console.log('🔧 isDevelopment:', isDevelopment);